<template>
  <div class="ch-reservation-card bg-white">
    <!-- Room strip -->
    <button @click="$emit('view-reservation')" class="ch-room-strip d-flex align-items-center p-3 w-100" type="button">
      <div class="flex-grow-1 overflow-hidden">
        <p class="mb-0 ch-room-num-line">Room · {{ reservation.roomNumber }}</p>
        <p class="mb-0 font-bold text-white ch-room-type-name">{{ reservation.room }}</p>
        <p class="mb-0 text-white ch-room-meta">
          {{ reservation.nights }} nights · {{ reservation.guests }} guests<template v-if="reservation.floor"> · {{ reservation.floor }}</template>
        </p>
      </div>
      <div class="ch-room-strip-action flex-shrink-0 ml-2 d-flex align-items-center justify-content-center">
        <i class="simple-icon-arrow-right text-white" style="font-size:12px"></i>
      </div>
    </button>

    <!-- Date row -->
    <div class="d-flex align-items-center p-3">
      <div class="flex-grow-1">
        <p class="ch-meta-label mb-0">CHECK-IN</p>
        <p class="mb-0 body-3-1 font-lato">{{ reservation.checkIn }}</p>
      </div>
      <div class="ch-day-pill d-flex align-items-center text-green bg-green-alpha border-green flex-shrink-0">
        <span class="font-bold" style="font-size:11px">Day {{ reservation.daysIn }}/{{ reservation.nights }}</span>
      </div>
      <div class="flex-grow-1 text-right">
        <p class="ch-meta-label mb-0">CHECK-OUT</p>
        <p class="mb-0 body-3-1 font-lato">{{ reservation.checkOut }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ConciergeReservationCard',
    props: {
      reservation: { type: Object, required: true },
    },
  }
</script>

<style scoped>
.ch-meta-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6B7886;
}

.ch-reservation-card {
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.08);
  border: 1px solid rgba(255,255,255,0.7);
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
}

.ch-room-strip {
  background: linear-gradient(135deg, var(--merchant-primary-color, #2B5F7A) 0%, #1a3a4b 100%);
  position: relative;
  border: none;
  outline: none;
  text-align: left;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: filter 0.15s;
}

button.ch-room-strip:active {
  filter: brightness(0.92);
}

.ch-room-strip::after {
  content: '';
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background: radial-gradient(circle at top right, rgba(255,255,255,0.1), transparent 70%);
  pointer-events: none;
}

.ch-room-strip-action {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  transition: background 0.15s;
}

button.ch-room-strip:active .ch-room-strip-action {
  background: rgba(255, 255, 255, 0.25);
}

.ch-room-num-line {
  font-size: 10px;
  font-weight: 700;
  color: rgba(255,255,255,0.55);
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin-bottom: 3px;
}

.ch-room-type-name {
  font-size: 15px;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ch-room-meta {
  font-size: 11.5px;
}

.ch-day-pill {
  border-radius: 8px;
  padding: 4px 8px;
  flex-shrink: 0;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/ConciergeReservationCard.vue